/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_CreatedInputs */

const en_admin_categories_created = /** @type {(inputs: Admin_Categories_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category created`)
};

const zh_admin_categories_created = /** @type {(inputs: Admin_Categories_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类已创建`)
};

/**
* | output |
* | --- |
* | "Category created" |
*
* @param {Admin_Categories_CreatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_created = /** @type {((inputs?: Admin_Categories_CreatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_CreatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_created(inputs)
	return zh_admin_categories_created(inputs)
});
export { admin_categories_created as "admin.categories.created" }